import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {CustomSelect} from './StyledComp';


const SelectBoolean = ({t, onChange, value, typeTitle, name,  allowNull, customTrueText, customFalseText, customAllText, ...props}) => {

  return (
    <CustomSelect
      name={name}
      onChange={onChange}
      absolute
      value={value}
      {...props}>
      <option disabled value="default">
        {typeTitle}
      </option>
      {allowNull && (
        <option value="all">
          {customAllText ? customAllText : t('all')}
        </option>
      )}
      <option value="1">
        {customTrueText ? customTrueText : t('yes')}
      </option>
      <option value="0">
        {customFalseText ? customFalseText : t('no')}
      </option>
    </CustomSelect>
  );
};

SelectBoolean.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  allowNull: PropTypes.bool,
  name: PropTypes.string.isRequired,
  typeTitle: PropTypes.string.isRequired,
  customTrueText: PropTypes.string,
  customFalseText: PropTypes.string,
  customAllText: PropTypes.string,
};

SelectBoolean.defaultProps = {
  allowNull: false,
};

export default withTranslation('common')(SelectBoolean);
